import BaseService from '../BaseService'
import axios from 'axios'

class AuthService extends BaseService {
    verify({params, query}) {
        return axios.get(`${this.resource}/email/verify/${params.userId}/${params.id}?expires=${query.expires}&signature=${query.signature}`)
    }

    resendVerificationEmail() {
        return axios.post(`${this.resource}/email/verification-notification`)
    }

    oauthLogin(payload) {
        return axios.post(`${this.resource}/lwa-login?notificationOff`, payload)
    }

    forgotPassword({payload}) {
        return axios.post(`${this.resource}/forgot-password`, payload)
    }

    resetPassword({payload}, signature) {
        return axios.post(`${this.resource}/reset-password?${signature}`, payload)
    }

    oauthRedirect(payload) {
        return axios.post(`${this.resource}/lwa-redirect?notificationOff`, payload)
    }

    csrfProtection() {
        return axios.get('/sanctum/csrf-cookie');
    }
}

export default new AuthService('')
